import getConfig from 'next/config';

import type { DadataBound, IAddressSuggest } from '@src/@types/dadata';
import { API_PATH } from '@src/config/routes';

import type { ILocation } from '../reducers/locations';
import client from '../utils/client';

export const locationSuggest = async (query: string): Promise<ILocation[]> => {
    const res = await client.get(`${getConfig().publicRuntimeConfig.gatewayUrl}/v1/locations/suggest`, {
        params: {
            q: query,
        },
    });

    return res.data;
};

export const loadMicroCreditsRegions = async (params?: { adsOnly?: boolean; seoActiveCitiesUrl?: string }) => {
    const { data } = await client.get(`${getConfig().publicRuntimeConfig.publicUrl}/v1/microcredit/regions/`, {
        params,
        timeout: 1500,
    });

    return data;
};

export const loadRegions = async (): Promise<ILocation[]> => {
    const { data } = await client.get(`${API_PATH}/location/regions`);

    return data;
};

export const loadRegionalCenters = async (): Promise<ILocation[]> => {
    const { data } = await client.get(`${API_PATH}/location/centers`);

    return data;
};

type TFindAddressesParams = {
    query: string;
    count?: number;
    from_bound?: { value: DadataBound };
    to_bound?: DadataBound;
};

export const findAddresses = async (params: TFindAddressesParams): Promise<IAddressSuggest[]> => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { query, to_bound = 'house', count = 10 } = params;

    const { data } = await client.post(
        `${getConfig().publicRuntimeConfig.apiGatewayUrl}/dadata/v1.0/suggest/address/`,
        {
            query,
            count,
            to_bound: { value: to_bound },
        },
    );

    return data.suggestions || [];
};
